
import { Component, Prop, Vue} from "vue-property-decorator";
import DashboardCardScaffold from "@/components/dashboard/cards/CardScaffold.vue";
import CardItemScaffold from "@/components/dashboard/cards/CardItemScaffold.vue";
import PostingModalWithButton from "@/components/postings/PostingModalWithButton.vue";
import RecruitingIcon from "@/components/icons/RecruitingIcon.vue";
import JobPostingIcon from "@/components/icons/JobPostingIcon.vue";
import SimplePersonIcon from "@/components/icons/SimplePersonIcon.vue";
import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
import timeRangeForNew from "@/helpers/cardInfoHelperFunctions/timeRangeForNew";
import { findNew } from "@/helpers/cardInfoHelperFunctions/findNewHelper";
import RouteNames from "@/entities/RouteNames";
import GET_POSTINGS from "@/apollo/dashboard/GetPostings.gql";
import Roles from "@/entities/Roles";
import CircleWithInitialsData from "@/entities/CircleWithInitialsData";
import { Posting } from "@/generated/graphql";

@Component({
  components: {
    DashboardCardScaffold,
    PostingModalWithButton,
    CardItemScaffold,
    JobPostingIcon,
    RecruitingIcon,
    SimplePersonIcon,
    CircleWithInitials,
  },
  apollo: {
    dashboardPostings: {
      query: GET_POSTINGS,
      variables() {
        return {
          postingFilter: this.filter.postings,
          newPostingFilter: this.filter.newPostings,
          applicationFilter: this.filter.applications,
        }
      },
      update(data) {
        return data;
      }
    }
  }
})
export default class DashboardPostings extends Vue {
  @Prop({type: String, required: true}) readonly companyId!: string;
  @Prop({type: Object, required: true}) readonly currentUser!: any;

  routes = RouteNames;
  dashboardPostings:any = null;

  get filter(): object {
    const postingConditions: any[] = [
      { active: { _eq: true } },
    ]
    if (this.currentUser.role == Roles.MANAGER) {
      postingConditions.push(
        { manager: {
            user: {
              id: { _eq: this.currentUser.id }
            }
          }
        }
      );
    }
    return {
      postings: { _and: postingConditions },
      newPostings: { _and: [
        { created_at: {_gt: timeRangeForNew(this.$moment) } },
        { active: { _eq: true} },
      ]},
      applications: { posting: { active: { _eq: true} } },
    }
  }

  get postings(): CircleWithInitialsData[] {
    if (!this.dashboardPostings?.postings) {
      return [];
    }
    return this.dashboardPostings.postings.map((p: Posting) => {
      return {
        name: p.job_title ?? "",
        id: p.id,
      };
    });
  }

  get postingsTotal(): undefined | number {
    if (!this.dashboardPostings?.postingsTotal) {
      return undefined;
    }
    return this.dashboardPostings.postingsTotal.aggregate.count;
  }

  get newPostings(): CircleWithInitialsData[] {
    if (!this.dashboardPostings?.postings) {
      return [];
    }
    const newItems = this.dashboardPostings.postings.filter((p: Posting) => findNew(p.created_at, this.$moment));

    if (!newItems.length) {
      return [];
    }

    return newItems.map((p: Posting) => {
      return {
        name: p.job_title ?? "",
        id: p.id,
      };
    });
  }

  get newPostingsTotal(): undefined | number {
    if (!this.dashboardPostings?.newPostingsTotal) {
      return undefined;
    }
    return this.dashboardPostings.newPostingsTotal.aggregate.count;
  }

  get applicantsTotal(): undefined | number {
    if (!this.dashboardPostings?.applicants) {
      return undefined;
    }
    return this.dashboardPostings.applicants
      .map((a: any) => {
        return a.applications_aggregate.aggregate.count;
      })
      .reduce((a: number, b: number) => a + b, 0);
  }
}
